var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9583H7.50033C2.97533 18.9583 1.04199 17.025 1.04199 12.5V7.49999C1.04199 2.97499 2.97533 1.04166 7.50033 1.04166H12.5003C17.0253 1.04166 18.9587 2.97499 18.9587 7.49999V12.5C18.9587 17.025 17.0253 18.9583 12.5003 18.9583ZM7.50033 2.29166C3.65866 2.29166 2.29199 3.65832 2.29199 7.49999V12.5C2.29199 16.3417 3.65866 17.7083 7.50033 17.7083H12.5003C16.342 17.7083 17.7087 16.3417 17.7087 12.5V7.49999C17.7087 3.65832 16.342 2.29166 12.5003 2.29166H7.50033Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81621 12.9833C8.64954 12.9833 8.49121 12.9167 8.37454 12.8L6.01621 10.4417C5.77454 10.2 5.77454 9.79999 6.01621 9.55832C6.25788 9.31666 6.65788 9.31666 6.89954 9.55832L8.81621 11.475L13.0995 7.19166C13.3412 6.94999 13.7412 6.94999 13.9829 7.19166C14.2245 7.43332 14.2245 7.83332 13.9829 8.07499L9.25788 12.8C9.14121 12.9167 8.98288 12.9833 8.81621 12.9833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTick);
export default __webpack_public_path__ + "static/media/outline-tick.416fa8e67c4a39e5323471153d551c24.svg";
export { ForwardRef as ReactComponent };